<template>
    <div class="ticketMessanger pa-10">
        <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 xl12>
                <v-card :elevation="0">
                    <v-toolbar color="blue-grey darken-1" dark>
                        <v-toolbar-title style="direction:rtl">تیکت #{{$route.params.code}}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <div class="MessageHolder pa-4">
                            <div class="msg pa-2 me mt-2">
                                <div class="msg-text pt-2 pb-2 ">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Qui, aspernatur dolorem optio laboriosam ullam atque? Cupiditate sapiente ab pariatur repellendus perferendis architecto debitis sit nesciunt, sunt cumque modi voluptatum error.</div>
                                <div class="msg-user-date pt-2"><span class="msg-user">You</span>-<span>2 مهر 1401</span></div>
                            </div>
                            <div class="msg pa-2 other mt-2">
                                <div class="msg-text pt-2 pb-2 ">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Qui, aspernatur dolorem optio laboriosam ullam atque? Cupiditate sapiente ab pariatur repellendus perferendis architecto debitis sit nesciunt, sunt cumque modi voluptatum error.</div>
                                <div class="msg-user-date pt-2"><span class="msg-user">You</span>-<span>2 مهر 1401</span></div>
                            </div>
                            <div class="msg pa-2 other mt-2">
                                <div class="msg-text pt-2 pb-2 ">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Qui, aspernatur dolorem optio laboriosam ullam atque? Cupiditate sapiente ab pariatur repellendus perferendis architecto debitis sit nesciunt, sunt cumque modi voluptatum error.</div>
                                <div class="msg-user-date pt-2"><span class="msg-user">You</span>-<span>2 مهر 1401</span></div>
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12 lg12 xl12 class="pa-5">
                                <v-text-field label="پاسخ" outlined dense rounded>
                                    <template  slot="append">
                                        <v-btn class="input-btn" color="blue" icon><v-icon>fa fa-paper-plane</v-icon></v-btn>
                                    </template>
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<style scoped>
    .input-btn
    {
        margin-top: -6px;
        position: relative;
        left: -19px;
    }
    .ticketMessanger
    {
        width:100%;
        min-height: 100vh;
        max-height: 100vh;
    }
    .MessageHolder
    {
        height: 100%;
        width: 100%;
        min-height: 500px;
        box-shadow: 0px 0px 2px -1px rgba(0,0,0,0.5) inset;
        -webkit-box-shadow: 0px 0px 2px -1px rgba(0,0,0,0.5) inset;
        -moz-box-shadow: 0px 0px 2px -1px rgba(0,0,0,0.5) inset;
    }
    .msg
    {
        max-width: 45%;
        min-height: 3rem;
        border-radius: 1rem;
        display: flex;
        align-items: center;
        text-align: justify;
        position: relative;
        flex-direction: column;
    }
    .msg::before
    {
        width: 1rem;
        height: 1rem;
        position: absolute;
        content: '';
        
    }
    .msg.me
    {
        background-color: #c1ffdc;
    }
    .msg.other
    {
        background-color: #eaeaea;
        right: 55%;
    }
    .msg.me::before
    {
        border-left: .5rem solid #c1ffdc;
        border-right: .5rem solid transparent;
        border-top: .5rem solid transparent;
        border-bottom: .5rem solid transparent;
        right: -1rem;
        top: 1rem;
    }
    .msg.other::before
    {
        border-left: .5rem solid transparent;
        border-right: .5rem solid #eaeaea;
        border-top: .5rem solid transparent;
        border-bottom: .5rem solid transparent;
        left: -1rem;
        top: 1rem;
    }
    .msg-user-date
    {
        text-align:right;
        width: 100%;
        border-top: .01rem solid rgba(0,0,0,.25);
    }
    .msg-user
    {
        font-weight: bolder;
    }
</style>
<script>
export default {
    name:"ticketDetail",
    data:()=>({}),
    methods:{
        Get()
        {
            
        }
    }
}
</script>